import { render } from "./KnotCarousel.vue?vue&type=template&id=154b8870&scoped=true"
import script from "./KnotCarousel.vue?vue&type=script&lang=js"
export * from "./KnotCarousel.vue?vue&type=script&lang=js"

import "./KnotCarousel.vue?vue&type=style&index=0&id=154b8870&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154b8870"]])

export default __exports__